export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.woff2?c52405129ae48097815d4da606003470";